/**
 * 常用每週工作時間預設，供一鍵套用。純函式，無 DOM／store 依賴。
 */
import type { WeekDays, WeekDaySpec } from '@bigint-project/core';
import { workingTime } from './time-format.js';

export type WeekDayPresetId = 'standard-5-2' | '24-hours' | 'night-shift';

export interface WeekDayPresetMeta {
  readonly id: WeekDayPresetId;
  readonly label: string;
  readonly description: string;
}

export const WEEKDAY_PRESETS: readonly WeekDayPresetMeta[] = [
  { id: 'standard-5-2', label: '標準週休二日', description: '週一至週五 09:00–18:00（含 12:00–13:00 休息），週六日休' },
  { id: '24-hours', label: '24 小時', description: '全週每日 00:00–24:00 皆為工作時間' },
  { id: 'night-shift', label: '夜班', description: '每日 22:00–翌日 06:00（拆成相鄰兩天的兩段時段）' },
];

const WORKING_DAY: WeekDaySpec = {
  working: true,
  times: [workingTime(9 * 60, 12 * 60), workingTime(13 * 60, 18 * 60)],
};
const NON_WORKING_DAY: WeekDaySpec = { working: false };
const FULL_DAY: WeekDaySpec = { working: true, times: [workingTime(0, 1440)] };
/** 夜班的「當日」段：22:00–24:00。翌日 00:00–06:00 段掛在隔天，因此每天的定義相同。 */
const NIGHT_SHIFT_DAY: WeekDaySpec = {
  working: true,
  times: [workingTime(0, 6 * 60), workingTime(22 * 60, 24 * 60)],
};

/** index 0 = 週日 … 6 = 週六，對齊 WeekDays。 */
export function buildWeekDayPreset(preset: WeekDayPresetId): WeekDays {
  switch (preset) {
    case 'standard-5-2':
      return [NON_WORKING_DAY, WORKING_DAY, WORKING_DAY, WORKING_DAY, WORKING_DAY, WORKING_DAY, NON_WORKING_DAY];
    case '24-hours':
      return [FULL_DAY, FULL_DAY, FULL_DAY, FULL_DAY, FULL_DAY, FULL_DAY, FULL_DAY];
    case 'night-shift':
      return [
        NIGHT_SHIFT_DAY,
        NIGHT_SHIFT_DAY,
        NIGHT_SHIFT_DAY,
        NIGHT_SHIFT_DAY,
        NIGHT_SHIFT_DAY,
        NIGHT_SHIFT_DAY,
        NIGHT_SHIFT_DAY,
      ];
    default: {
      const _exhaustive: never = preset;
      throw new Error(`unknown preset: ${String(_exhaustive)}`);
    }
  }
}
